import { useQuery } from '@apollo/client';
import {
  MostScheduledJobsDocument,
  MostScheduledJobsQuery,
} from 'src/graphql/generated/graphql';

export const useMostScheduledJobsFiltered = ({
  filter,
  pagination,
}: {
  filter?: { commandId?: string; devices?: string[] };
  pagination?: {
    limit: number;
    offset: number;
  };
}) => {
  const { data, loading } = useQuery<MostScheduledJobsQuery>(
    MostScheduledJobsDocument,
    {
      variables: {
        filter: filter,
        pagination: pagination || {
          limit: 1,
          offset: 0,
        },
      },
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-and-network',
    },
  );

  return {
    data: data?.mostScheduledJobs,
    loading,
  };
};
